import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function Guide() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="guide" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              观影指南
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              常见问题，一次说清
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              把浏览时最容易卡住的几个点整理成问答，点击问题即可展开查看。内容为一般性说明，便于快速建立整体印象。
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={faq.q}
                  className="overflow-hidden rounded-lg border border-background-200/70 bg-background-50"
                >
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpen(isOpen ? null : i)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                      {faq.q}
                    </span>
                    <span className="flex h-7 w-7 flex-none items-center justify-center rounded-full bg-background-100 text-foreground-700">
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                  {isOpen && (
                    <p className="animate-fade-in px-5 pb-5 text-xs leading-relaxed text-foreground-600 md:text-sm">
                      {faq.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}